module.exports = __webpack_public_path__ + "static/img/1046_phase_function_Paper_Points.d4c27d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1046_phase_function_Paper_Points.png
// module id = KOPy
// module chunks = 0